import { Link } from 'react-router-dom';
import { primaryNavigation, serviceNavigation } from '../../data/navigation';

const logoSrc = `${process.env.PUBLIC_URL}/images/logos/logo-light.svg`;

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <section className="site-footer__brand" aria-label="Company summary">
          <div className="footer-logo" aria-label="Evon Industrial Services">
            <img src={logoSrc} alt="" aria-hidden="true" />
            <strong>Evon</strong>
          </div>
          <p>Industrial gearbox and hydraulic repair services across Canada.</p>
        </section>

        <nav aria-label="Footer navigation">
          <h3>Company</h3>
          {primaryNavigation.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </nav>

        <nav aria-label="Footer service navigation">
          <h3>Services</h3>
          {serviceNavigation.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </nav>

        <section className="site-footer__contact" aria-label="Contact information">
          <h3>Contact Us</h3>
          <p>(437) 435-7083</p>
          <p>contact@evonindustrial.com</p>
          <p>Serving customers across Canada</p>
        </section>
      </div>
      <div className="container site-footer__bottom">
        <p>&copy; 2026 Evon Industrial Services. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
